import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

interface SectionGridProps {
  title: string;
  subtitle?: string;
  videos: VideoItem[];
  moreLink?: string;
  moreLabel?: string;
  showDescription?: boolean;
}

export default function SectionGrid({
  title,
  subtitle,
  videos,
  moreLink,
  moreLabel = '查看更多',
  showDescription = false,
}: SectionGridProps) {
  return (
    <section className="w-full py-10">
      <div className="flex items-end justify-between mb-6 gap-4">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            <a href={`#${title}`} className="cursor-pointer">{title}</a>
          </h2>
          {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
        </div>
        {moreLink && (
          <Link
            to={moreLink}
            className="flex items-center gap-1 text-sm text-primary-700 hover:text-primary-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            {moreLabel}
            <i className="ri-arrow-right-line"></i>
          </Link>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {videos.map((video) => (
          <VideoCard key={video.id} video={video} showDescription={showDescription} />
        ))}
      </div>
    </section>
  );
}